var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.map_link())?_c('div',{staticClass:"map-btn"},[_c('a',{attrs:{"href":_vm.map_link(),"target":"_blank"}},[_vm._v(" карта ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }